/*jslint node: true, browser: true, todo: true*/
"use strict";

var $ = require("pli/jquery");
var ko = require("pli/knockout");
var pli = require("pli/forms");
var pliObservable = require("pli/forms-knockoutcontrols");
var map = require("../widget-map-ts");
var computeDescription = require("../document-landright-ts/landsRightsEditGridViewModel").computeDescription;

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// DocumentViewModelExtensions mixin class
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//---------------------------------------
function DocumentViewModelExtensions(factories) {
    /// <summary>
    /// Define viewmodel.
    /// </summary>
    this.guid = ko.observable(null);
    this.id = this.number = pliObservable(null, null, "required");
    this.splits = factories.splits.createObservableArray();

    this.toggleMapOff = DocumentViewModelExtensions.prototype.toggleMapOff.bind(this);
    this.toggleMapOn = DocumentViewModelExtensions.prototype.toggleMapOn.bind(this);
    this.printMap = DocumentViewModelExtensions.prototype.printMap.bind(this);

    this.extras.userName = ko.observable();
    this.extras.mapOn = ko.observable(false);
}


//---------------------------------------
DocumentViewModelExtensions.prototype.applyServerCalculationResult = function applyDocumentResult(context) {
    context.visit(this.splits, "splits");
};


//---------------------------------------
DocumentViewModelExtensions.prototype.buildServerCalculationData = function buildDocumentData(context) {
    var splits = context.visit(this.splits);
    return (splits === null ? null : { splits: splits });
};


//---------------------------------------
DocumentViewModelExtensions.prototype.completeViewModel = function completeDocument() {
    this.extras.map = new map.MapServerComputed({
        mapRequestData: ko.computed(DocumentViewModelExtensions.prototype._getMapRequestData, this),
        mapFeatureCallback: DocumentViewModelExtensions.prototype._mapFeatureCallback.bind(this),
        isReady: this.extras.isReady,
        emptyMessage: "There are no legal descriptions for this split."
    });

    ko.computed(function () {
        var crumbs = pli.forms.crumbs();
        if (crumbs.end && crumbs.end.hash.indexOf("landsRights", crumbs.end.hash.length - "landsRights".length) !== -1) {
            this.showControls();
            return;
        }
        this.hideControls();
    }, this.extras.map);

    // TODO: Remove setTimeout once https://github.com/pandell/web-pli/issues/440 is fixed
    // SlickGrid does not render the grid correctly if the grid is activated
    // before the page is visible. This ensures the grid dimensions are recomputed
    // if the grid is already active when the form initially becomes visible.
    var initialGridResizeComputed = ko.computed(function () {
        if (this.extras.state.isReady() && this.splits.current()) {
            var editGrid = this.splits.current().extras.landsRightsEditGrid.editGrid;
            if (editGrid.active()) {

                setTimeout(function () { editGrid.apply({ resize: true }); }, 0);
            }
            initialGridResizeComputed.dispose();
        }
    }, this);
};


//---------------------------------------
DocumentViewModelExtensions.prototype.loadViewModel = function loadDocument(record) {
    this.guid(record.guid || null);
    this.id.load(record.id);
    this.splits.loadViewModel(record.splits);
    if (this.splits.peek().length === 0) {
        var newSplit = this.splits.createItem();

        if (ko.isObservable(newSplit.rentalPercentage)) {
            newSplit.rentalPercentage(100);
        }

        this.splits.push(newSplit);
    }
    this.extras.userName(record.userName || "Unknown");
};


//-------------------------------------------
DocumentViewModelExtensions.prototype.toggleMapOff = function toggleMapOff(document) {
    document.extras.mapOn(false);
};


//-------------------------------------------
DocumentViewModelExtensions.prototype.toggleMapOn = function toggleMapOn(document) {
    document.extras.mapOn(true);
};


//-------------------------------------------
DocumentViewModelExtensions.prototype.printMap = function printMap() {
    // open the default print dialogue
    // the print style we added to document.css will take care of the rest
    window.print();
};


//---------------------------------------
DocumentViewModelExtensions.prototype._getMapRequestData = function getMapRequestData() {
    var locations = [];
    var currentSplit = this.splits.current();

    if (currentSplit.tracts.peek()) {
        ko.utils.arrayForEach(currentSplit.tracts(), function (tract) {
            var tractId = tract.id;

            if (tract.tractItems) {
                ko.utils.arrayForEach(tract.tractItems, function (item) {
                    if (!item.isRight) {
                        var land = item.land,
                            landId = (land.location + " " + land.sections).trim();

                        if (landId) {
                            locations.push(
                                {
                                    id: tractId + ":" + landId,
                                    isValid: true,
                                    legalDescription: {
                                        format: land.format,
                                        location: land.location,
                                        sections: land.sections
                                    },
                                    shortDisplayName: landId,
                                    longDisplayName: landId
                                }
                            );
                        }
                    }
                });
            }
        });
    }

    return locations;
};


//-------------------------------------------
DocumentViewModelExtensions.prototype._mapFeatureCallback = function mapFeatureCallback(feature) {
    var featureIds = feature.properties.docId.split("|"),
        featureId = featureIds[0],
        tractId = featureId.split(":")[0],
        landId = featureId.split(":")[1];

    var tract = ko.utils.arrayFirst(this.splits.current.peek().tracts.peek(), function (tracts) {
        return tracts.name === tractId;
    });

    if (tract) {
        var popupHtml = ko.pureComputed(DocumentViewModelExtensions.prototype._mapPopupContentFactory(tract, landId), this);
        feature.bindPopup(popupHtml, { customLayout: true, closeButton: ".close" });
    }
};


//-------------------------------------------
DocumentViewModelExtensions.prototype._mapPopupContentFactory = function createPopupContentFactory(tract, landId) {
    // Extract the land
    var landItem = ko.utils.arrayFirst(tract.tractItems, function (item) {
        if (!item.isRight) {
            var id = computeDescription(ko.utils.extend({ type: "land" }, item.land));
            return id === landId;
        }

        return null;
    });

    // Extract the rights
    var rightItems = ko.utils.arrayFilter(tract.tractItems, function (item) {
        return item.isRight;
    });

    return function computePopupContent() {
        // Build popup div container
        var popupDiv = $("<div class='pliTooltip'>"
            + "<div class='pliTooltip-content'>"
            + "<div class='pliTooltip-header'>Tract " + tract.name + "</div>"
            + "<div class='pliTooltip-list-container'></div>"
            + "<div class='pliTooltip-footer'><a class='close'><i></i> close</a></div>"
            + "</div>"
            + "</div>");

        var $listContainer = $(".pliTooltip-list-container", popupDiv);

        // Builds the land details and inject as a line item in popup div
        if (landItem) {
            var landDescription = computeDescription(ko.utils.extend({ type: "land" }, landItem.land));
            var landDetails = "";

            landDetails += "<div>" + landDescription + "</div>";

            // Land production
            if (landItem.productionType) {
                if (landItem.productionType === "P") {
                    landDetails += "<div class='producing'>Producing</div>";
                } else if (landItem.productionType === "NP") {
                    landDetails += "<div class='nonProducing'>Non-producing</div>";
                }
            }

            // Inject the land details into the land item row.
            var landLi = $("<li class='toolTipRow'>"
                + "<a>"
                + "<span class='toolTip-icon sprite-land-16'></span>"
                + "<span class='toolTip-details'>"
                + landDetails
                + "</span>"
                + "</a></li>");

            $listContainer.append(landLi); // Add the land details row
        }

        // Build the right details and inject as line items in div
        ko.utils.arrayForEach(rightItems, function (item) {
            var rightDescription = computeDescription(ko.utils.extend({ type: "right" }, item.right));
            var rightDetails = "<div>" + rightDescription + "</div>";

            var rightLi = $("<li class='toolTipRow'>"
                + "<a>"
                + "<span class='toolTip-icon sprite-right-16'></span>"
                + "<span class='toolTip-details'>"
                + rightDetails
                + "</span>"
                + "</a></li>");

            $listContainer.append(rightLi); // Add the right details row
        });

        return popupDiv[0];
    };
};



//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Exports
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//---------------------------------------
module.exports = {
    createFactories: function createExtraDocumentFactories(rootId, createSplitsFactory) {
        return {
            splits: createSplitsFactory(rootId)
        };
    },
    mixins: {
        applyDocumentResult: DocumentViewModelExtensions.prototype.applyServerCalculationResult,
        buildDocumentData: DocumentViewModelExtensions.prototype.buildServerCalculationData,
        completeDocument: DocumentViewModelExtensions.prototype.completeViewModel,
        initDocument: DocumentViewModelExtensions,
        loadDocument: DocumentViewModelExtensions.prototype.loadViewModel
    }
};



//////////////////
// WEBPACK FOOTER
// ./app/document/documentViewModelExtensions.js
// module id = 575
// module chunks = 49